import {Dispatch} from "redux";
import {apiErrorSetAction} from "../../../app/apiError/actions";
import {ErrorDto, getErrorDtoFromApiError} from "../../../models/dtos/error.dto";
import {Errors} from "../../../utilities/errors";
import {getMeRequest} from "../getMe/repository";
import {PAYMENT_FAIL_FAIL, PAYMENT_FAIL_RESET, PAYMENT_FAIL_START, PAYMENT_FAIL_SUCCESS,} from "./constants";
import {paymentFailRequest} from "./repository";
import {
  PaymentFailFailAction,
  PaymentFailResetAction,
  PaymentFailStartAction,
  PaymentFailSuccessAction,
} from "./types";

const paymentFailStartAction = (): PaymentFailStartAction => {
  return {
    type: PAYMENT_FAIL_START,
  };
}
const paymentFailSuccessAction = (payload: boolean): PaymentFailSuccessAction => {
  return {
    type: PAYMENT_FAIL_SUCCESS,
    payload: payload,
  };
}
const paymentFailFailAction = (error: ErrorDto): PaymentFailFailAction => {
  return {
    type: PAYMENT_FAIL_FAIL,
    error: error,
  };
}
const paymentFailResetAction = (): PaymentFailResetAction => {
  return {
    type: PAYMENT_FAIL_RESET,
  };
}

export const paymentFail = () => async (
  dispatch: Dispatch
) => {
  try {
    dispatch(paymentFailStartAction());
    await paymentFailRequest();
    await getMeRequest(dispatch);
    dispatch(apiErrorSetAction(Errors.paymentError));
    dispatch(paymentFailSuccessAction(true));
  } catch (error) {
    dispatch(paymentFailFailAction(getErrorDtoFromApiError(error)));
  }
};

export const paymentFailReset = () => (
  dispatch: Dispatch
) => {
  dispatch(paymentFailResetAction());
};
